export const staticDemo = [
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-07-08",
        deployment_id: "2277d2dc-84cc-411a-b8eb-66fcb240711d"
    },

    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-04-02",
        deployment_id: "e22901ef-5b7d-46f7-b10a-84be0203cdf8"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-06-07",
        deployment_id: "d76cf401-73e9-460d-9ad0-9d77d42f082b"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-04-02",
        deployment_id: "7cb8511c-d3b7-4bf5-b76a-30e18fa7daf0"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-08-31",
        deployment_id: "ade2c809-cd72-4afb-adf1-70b80bf7225f"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-08-31",
        deployment_id: "d07a60d9-0c1b-4ddd-8e7a-0cccb08ab9f7"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-08-31",
        deployment_id: "9ba24017-0f95-4d93-a553-879d6fc12b23"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-08-31",
        deployment_id: "55fc7b3d-8905-4dbc-b5a8-6d05d4d03cb3"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-02-18",
        deployment_id: "efb5b3a5-ba01-42be-ba0f-3447fc49bbb0"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-02-18",
        deployment_id: "850da3b1-8057-4177-acf3-80f63fb7126c"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-02-18",
        deployment_id: "491753f0-7751-48f9-bb49-056f12fe78ee"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-02-18",
        deployment_id: "ba7958c2-d291-4a1f-b847-a88a9fc95b1a"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-11-15",
        deployment_id: "872cbb57-459c-43b9-ac85-edfa5acd9e37"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-11-15",
        deployment_id: "6700301b-6e0c-4cc6-bfde-1d8551be623b"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-11-15",
        deployment_id: "901aa1c8-6768-4f44-be9d-f7b4a54cf7ed"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-11-15",
        deployment_id: "44568c8b-0276-45c2-a4b4-88cae0087879"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-08-20",
        deployment_id: "eb0af7bb-70f4-4749-ad8a-be5fc8436cff"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-08-20",
        deployment_id: "eae6b40d-9066-4a83-99b6-3cff9b0a4257"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-11-22",
        deployment_id: "14376741-eb24-4536-b804-4bfbf7a9a8d9"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-11-22",
        deployment_id: "8f721e14-9411-4701-b5e2-287ef339d25c"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-08-20",
        deployment_id: "5ebb58dd-0a54-4223-8edf-947d6061b1bb"
    },
    {
        machine_id: "377c4b13-2dc0-496f-b298-3e43bdf7a747",
        date: "2025-10-03",
        deployment_id: "cfac67b4-4ca9-4f9d-a93b-8e0f6576fb4b"
    }
]